import { render, staticRenderFns } from "./SuccessSubmitForm20.vue?vue&type=template&id=7ff900fe&scoped=true"
import script from "./SuccessSubmitForm20.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff900fe",
  null
  
)

export default component.exports